export { View_Mobile } from "./Mobile";
